import { fetchWithToken, getAvaBackendEndpoint } from './http';

export const terminateCall = async (user, sid) => {
  const res = await fetchWithToken(
    `${getAvaBackendEndpoint()}/api/v1/calls/${sid}?avaId=${
      user.avaId
    }&firebaseAuthUID=${user.id}`,
    {
      method: 'DELETE',
      json: true,
    }
  );
  if (res.status === 400) {
    const data = await res.json();
    const error =
      data &&
      data.error &&
      data.error.error &&
      data.error.error.content &&
      data.error.error.content.message;
    throw new Error(error);
  } else if (res.status !== 204) {
    throw new Error('Unexpected error.');
  } else {
    return 'Call ended.';
  }
};
